var render = function render(){var _vm=this,_c=_vm._self._c;return (
    this.$vuetify.breakpoint.name == 'md' ||
    this.$vuetify.breakpoint.name == 'lg' ||
    this.$vuetify.breakpoint.name == 'xl'
  )?_c('loginDekstop'):_c('v-container',{attrs:{"fill-height":""}},[_c('loginMobile')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }